import React, { useState } from "react";
import PropTypes from "prop-types";
import { FiTruck, FiChevronUp, FiChevronDown } from "react-icons/fi";

import {
  AccordionHeader,
  AccordionLabel,
  Chevron,
  AccordionContent,
  DataText,
  AlterLink,
} from "../styles";

function formatAddress(address) {
  if (!address || !Object.keys(address).length) return "";
  const street = [address.streetName, address.number].filter(Boolean).join(", ");
  const cityState = [address.city, address.state].filter(Boolean).join("/");
  const zip = address.zipCode || address.cep;
  return [street, address.complement, address.neighborhood, cityState, zip]
    .filter(Boolean)
    .join(" - ");
}

export default function DeliveryAddressAccordion({ address, onAlterar }) {
  const [open, setOpen] = useState(true); // inicia aberto (spec)
  const formatted = formatAddress(address);

  return (
    <div>
      <AccordionHeader type="button" onClick={() => setOpen((v) => !v)}>
        <AccordionLabel>
          <FiTruck />
          Endereço de entrega
        </AccordionLabel>
        <Chevron>{open ? <FiChevronUp /> : <FiChevronDown />}</Chevron>
      </AccordionHeader>

      {open && (
        <AccordionContent>
          <DataText>
            {formatted || "Nenhum endereço selecionado"}
          </DataText>
          <AlterLink onClick={onAlterar}>Alterar</AlterLink>
        </AccordionContent>
      )}
    </div>
  );
}

DeliveryAddressAccordion.propTypes = {
  address: PropTypes.object,
  onAlterar: PropTypes.func,
};
